<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row justify="space-between" no-gutters align="center">
        <v-col cols="12" md="5">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Template de proposta comercial</div>
                <div class="text text--thin mb-2">Configure o padrão utilizado na visualização da proposta comercial</div>
              </v-col>
              <v-col cols="12" md="5">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>article</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-btn @click="dialogWildcards = true" color="primary" class="mt-1"><v-icon class="mr-1">switch_access_shortcut</v-icon>Wildcards</v-btn>
      </v-row>
      <v-tabs
        next-icon="chevron_right"
        prev-icon="chevron_left"
        show-arrows
        class="ui-tabs"
        v-model="tabs">
        <v-tab link to="#textos-template">
          <v-icon>article</v-icon> Textos do template
        </v-tab>
        <v-tab link to="#imagens-template">
          <v-icon>image</v-icon> Imagens do template
        </v-tab>
        <v-tab link to="#cores-template">
          <v-icon>palette</v-icon> Cores do template
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item class="px-1 pb-1" id="textos-template">
          <v-card>
            <v-data-table
              :headers="headers_textos"
              :items="textos_template"
              :items-per-page="50"
              multi-sort
              class="elevation-1 base_table"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:item.actions="{ item }">
                <v-row no-gutters align="end" justify="center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialog(item, 'textos')" color="primary" class="mr-2">
                        edit
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item class="px-1 pb-1" id="imagens-template">
          <v-card>
            <v-data-table
              :headers="headers_imagens"
              :items="imagens_template"
              :items-per-page="50"
              multi-sort
              class="elevation-1 base_table"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:item.imagem="{ item }">
                <img v-if="item.imagem" class="imagem" :src="item.imagem" alt="Imagem">
                <span v-else> - </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-row no-gutters align="end" justify="center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialog(item, 'imagens')" color="primary" class="mr-2">
                        edit
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item class="px-1 pb-1" id="cores-template">
          <v-card>
            <v-data-table
              :headers="headers_cores"
              :items="cores_template"
              :items-per-page="50"
              multi-sort
              class="elevation-1 base_table"
              :footer-props="{
                itemsPerPageOptions: [5,10,15,20,25,50,100],
                showFirstLastPage: true,
                firstIcon: 'skip_previous',
                lastIcon: 'skip_next',
                prevIcon: 'chevron_left',
                nextIcon: 'chevron_right'
              }"
              :header-props="{
                sortIcon: 'north',
              }"
            >
              <template v-slot:item.cor="{ item }">
                <span class="text"><v-chip class="mr-2" :color="item.cor"></v-chip> {{item.cor}}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-row no-gutters align="end" justify="center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="openDialog(item, 'cores')" color="primary" class="mr-2">
                        edit
                      </v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                </v-row>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="550px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Editar template
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formTemplates">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="template.nome"
                label="Nome*"
                autofocus
                outlined
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0" v-if="tipoItem === 'textos'">
              <v-text-field
                v-model="template.tipo"
                label="Tipo*"
                outlined
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 pb-0" v-if="tipoItem === 'imagens'">
              <v-text-field
                v-model="template.dimensoes"
                label="Dimensões*"
                outlined
                :disabled="true"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-4" v-if="tipoItem === 'cores'">
              <div class="text-h3 mb-3">
                Selecione a cor:
              </div>
              <div>
                <v-menu offset-y v-model="openColorPrimary" :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-row no-gutters justify="start">
                      <v-btn :loading="salvando" :disabled="salvando" v-on="on" v-bind="attrs" rounded :style="'background-color:' + template.cor" class="height_btn"></v-btn>
                    </v-row>
                  </template>
                  <v-color-picker
                    dot-size="13"
                    mode="hexa"
                    hide-inputs
                    hide-mode-switch
                    v-model="corSelecionada"
                  ></v-color-picker>
                </v-menu>
              </div>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0" v-if="tipoItem === 'textos'">
              <v-textarea
                outlined
                no-resize
                rows="5"
                v-model="template.texto"
                :loading="salvando"
                :disabled="salvando"
                label="Descrição"
              ></v-textarea>
              <v-btn @click="dialogWildcards = true" color="primary" class="mb-2"><v-icon class="mr-1">switch_access_shortcut</v-icon>Wildcards</v-btn>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0" v-if="tipoItem === 'imagens'">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="template.imagem"
                prepend-icon="image"
                label="Adicionar imagem"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(template.imagem)"
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="tipoItem === 'imagem' && !isObject(template.imagem)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="template.imagem">
                  <img alt="Imagem" :src="template.imagem" class="logotipo">
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditTemplate()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover o imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogWildcards" max-width="500">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Wildcards
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogWildcards = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-simple-table fixed-header height="350px">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Código
                </th>
                <th class="text-right">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item,index) in wildcards"
                :key="index"
              >
                <td>{{ item.nome }}</td>
                <td align="end">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="copiarWildcard(item.nome)" color="primary" class="mr-2">
                        content_copy
                      </v-icon>
                    </template>
                    <span>Copiar</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogWildcards = false"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  watch: {
    corSelecionada () {
      if (this.corSelecionada) {
        this.template.cor = this.corSelecionada.hexa
        console.log(this.template.cor, 'this.template.cor')
      }
    }
  },
  data () {
    return {
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogDeletarImagem: false,
      tabs: 0,
      openColorPrimary: false,
      dialogWildcards: false,
      tipoItem: null,
      tipos_textos: ['Texto curto', 'Texto longo'],
      corSelecionada: null,
      wildcards: [
        {
          nome: '[nome-empresa]'
        },
        {
          nome: '[razao-social-empresa]'
        },
        {
          nome: '[cnpj-empresa]'
        },
        {
          nome: '[telefone-empresa]'
        },
        {
          nome: '[celular-empresa]'
        },
        {
          nome: '[email-empresa]'
        },
        {
          nome: '[validade-proposta]'
        },
        {
          nome: '[nome-cliente]'
        },
        {
          nome: '[telefone-cliente]'
        },
        {
          nome: '[celular-cliente]'
        },
        {
          nome: '[email-cliente]'
        },
        {
          nome: '[data-geracao-proposta]'
        },
        {
          nome: '[numero-da-proposta]'
        },
        {
          nome: '[potencia-proposta]'
        },
        {
          nome: '[potencia-modulo-proposta]'
        },
        {
          nome: '[valor-total-proposta]'
        }
      ],
      headers_textos: [
        { text: 'Nome', value: 'nome', align: 'start', width: 500 },
        { text: 'Tipo', value: 'tipo', width: 120 },
        { text: 'Descrição', value: 'texto_show' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      textos_template: [],
      headers_imagens: [
        { text: 'Nome', value: 'nome', align: 'start', width: 500 },
        { text: 'Dimensões', value: 'dimensoes', width: 400 },
        { text: 'Imagem', value: 'imagem' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      imagens_template: [],
      headers_cores: [
        { text: 'Nome', value: 'nome', align: 'start' },
        { text: 'Cor', value: 'cor' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      cores_template: [],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      template: {
        nome: '',
        tipo: '',
        cor: ''
      },
      templatePadrao: null
    }
  },
  methods: {
    async copiarWildcard (item) {
      try {
        await navigator.clipboard.writeText(item)
        this.$root.SnackControl.open(this, {
          text: 'Wildcard copiado :)',
          color: 'success'
        })
      } catch ($e) {
        this.$root.SnackControl.open(this, {
          text: 'Ops, ocorreu um erro ao copiar o Wildcard!',
          color: 'error'
        })
      }
    },
    async loadFunctions () {
      await this.getTemplates()
      await this.getTextos()
      await this.getImagens()
      await this.getCores()
      this.loading = false
    },
    async getTemplates () {
      this.loading = true
      await Api.get('templates-comerciais')
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.templatePadrao = res.data[0]
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os templates!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getTextos () {
      this.loading = true
      await Api.get(`templates-comerciais/${this.templatePadrao.uuid_tec_id}/textos`)
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.textos_template = []
            res.data.map(texto => {
              this.textos_template.push({
                nome: texto.tet_nome,
                tipo: this.tipos_textos[texto.tet_tipo - 1],
                texto: texto.tet_texto,
                texto_show: this.limitaTexto(texto.tet_texto),
                uuid_tet_id: texto.uuid_tet_id
              })
            })
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os textos do template!',
            color: 'error'
          })
        })
    },
    async getImagens () {
      this.loading = true
      await Api.get(`templates-comerciais/${this.templatePadrao.uuid_tec_id}/imagens`)
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.imagens_template = []
            res.data.map(imagem => {
              this.imagens_template.push({
                nome: imagem.tei_nome,
                dimensoes: imagem.tei_dimensoes,
                imagem: imagem.tei_imagem,
                uuid_tei_id: imagem.uuid_tei_id
              })
            })
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as imagens do template!',
            color: 'error'
          })
        })
    },
    async getCores () {
      this.loading = true
      await Api.get(`templates-comerciais/${this.templatePadrao.uuid_tec_id}/cores`)
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.cores_template = []
            res.data.map(cor => {
              this.cores_template.push({
                nome: cor.tcc_nome,
                cor: cor.tcc_cor,
                uuid_tcc_id: cor.uuid_tcc_id
              })
            })
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as cores do template!',
            color: 'error'
          })
        })
    },
    limitaTexto (texto) {
      if (!texto || texto.length <= 300) return texto
      return `${texto.substr(0, 299)}...`
    },
    saveEditTemplate () {
      if (!this.$refs.formTemplates.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }

      this.salvando = true

      if (this.tipoItem === 'textos') {
        this.template = {
          tet_nome: this.template.nome,
          tet_texto: this.template.texto,
          uuid_tet_id: this.template.uuid_tet_id
        }
      }
      if (this.tipoItem === 'cores') {
        this.template = {
          tcc_nome: this.template.nome,
          tcc_cor: this.template.cor,
          uuid_tcc_id: this.template.uuid_tcc_id
        }
      }
      if (this.tipoItem === 'imagens') {
        this.template = {
          tei_nome: this.template.nome,
          tei_dimensoes: this.template.dimensoes,
          tei_imagem: this.template.imagem,
          uuid_tei_id: this.template.uuid_tei_id
        }
      }

      const formData = new FormData()
      Object.keys(this.template).map((key) => {
        if (key === 'tei_imagem') {
          if (this.$refs.file) {
            formData.append(`tei_imagem`, this.template.tei_imagem)
          }
        } else {
          if (this.template[key] != null) {
            formData.append(key, this.template[key])
          }
        }
      })

      let endpoint = `templates-comerciais/${this.templatePadrao.uuid_tec_id}/${this.tipoItem}/edita`

      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Template atualizada com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.loadFunctions()
        })
        .catch((error) => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeImagem () {
      this.template.imagem = ''
      this.template.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    openDialog (item, tipoItem) {
      this.template = JSON.parse(JSON.stringify(item))
      this.tipoItem = tipoItem
      this.dialogNovo = true
    },
    closeDialog () {
      this.template = {
        nome: '',
        tipo: '',
        cor: ''
      }
      if (this.$refs.formTemplates) {
        this.$refs.formTemplates.resetValidation()
      }
      this.dialogNovo = false
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.height_btn {
  height: 60px!important;
  border: 1px $text solid;
  min-width: 60px!important;
}
.logotipo {
  max-height: 250px;
  max-width: 250px;
}
.imagem {
  max-height: 100px;
  margin: 5px 0;
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/TemplateProposta.vue